// A&K Atelier monogram — inspired by client sketches:
// classical pediment / cornice on top, "A & K" serif monogram,
// and a symmetric acanthus flourish below. Drawn in gold.
const Logo = ({ size = 46, className = "", animate = false }) => (
  <svg
    viewBox="0 0 240 170"
    width={size}
    height={size}
    className={`${className} ${animate ? "logo-draw" : ""}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="A&K Atelier"
    role="img"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient id="akGold" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#E8C96A" />
        <stop offset="55%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#B8902A" />
      </linearGradient>
    </defs>

    <g stroke="url(#akGold)" strokeLinecap="round" strokeLinejoin="round">
      {/* Pediment / cornice — outer raking lines */}
      <path d="M34 56 L120 16 L206 56" strokeWidth="4" fill="none" />
      <path d="M48 56 L120 26 L192 56" strokeWidth="2" fill="none" opacity="0.85" />
      {/* Keystone finial at apex */}
      <path d="M120 11 l6 7 -6 7 -6 -7 z" strokeWidth="1.6" fill="url(#akGold)" />
      {/* Horizontal cornice band */}
      <line x1="30" y1="60" x2="210" y2="60" strokeWidth="3.5" />
      <line x1="36" y1="66" x2="204" y2="66" strokeWidth="1.4" opacity="0.7" />

      {/* Bottom symmetric acanthus flourish */}
      <path d="M120 142 q28 -8 50 2 q12 5 6 14 q-6 8 -13 2 q-5 -4 1 -7" strokeWidth="2.2" fill="none" />
      <path d="M120 142 q-28 -8 -50 2 q-12 5 -6 14 q6 8 13 2 q5 -4 -1 -7" strokeWidth="2.2" fill="none" />
      <path d="M120 138 l8 6 -8 6 -8 -6 z" strokeWidth="1.4" fill="url(#akGold)" />
      <line x1="104" y1="144" x2="80" y2="144" strokeWidth="1.2" opacity="0.6" />
      <line x1="136" y1="144" x2="160" y2="144" strokeWidth="1.2" opacity="0.6" />
    </g>

    {/* A & K serif monogram */}
    <g fill="url(#akGold)" fontFamily="'Cormorant Garamond', serif" fontWeight="600">
      <text x="86" y="118" fontSize="64" textAnchor="middle">A</text>
      <text x="154" y="118" fontSize="64" textAnchor="middle">K</text>
      <text x="120" y="122" fontSize="26" textAnchor="middle" fontStyle="italic">&amp;</text>
    </g>
  </svg>
);

export default Logo;
